import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NumberFormatWithDotRendererComponent } from './number-format-with-dot-renderer.component';


@NgModule({
  declarations: [ NumberFormatWithDotRendererComponent ],
  exports: [ NumberFormatWithDotRendererComponent ],
  imports: [
    CommonModule
  ]
})
export class NumberFormatWithDotRendererModule { }
